import { render } from "./doctor-profile-settings.vue?vue&type=template&id=da7a4c0e"
import script from "./doctor-profile-settings.vue?vue&type=script&lang=js"
export * from "./doctor-profile-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__